export default __webpack_public_path__ + "static/media/projeto6.8575439e.svg";